import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import { legacyBillingHref } from '@/components/admin/billing/billingNavigation';

/**
 * Student Billing came home to Enrollments: `/admin/billing` and
 * `/admin/billing/students/:participantId` redirect, with `replace`, to the
 * Enrollments page that means the same thing (`legacyBillingHref`), so a link
 * or bookmark made before the move still lands on its student or queue.
 */
const LegacyBillingRedirect: React.FC = () => {
  const { participantId } = useParams();
  const location = useLocation();
  return (
    <Navigate
      replace
      to={legacyBillingHref(
        new URLSearchParams(location.search),
        participantId
      )}
    />
  );
};

export default LegacyBillingRedirect;
